export default __webpack_public_path__ + "static/media/amazon-logo.2082e809.svg";